import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index.vue'
import Notice from '@/views/notice/index.vue'
import noticeIndex from '@/views/notice/noticeIndex.vue'
import noticeList from '@/views/notice/noticeList.vue'
import coList from '@/views/notice/coList.vue'
import stock from '@/views/notice/stock.vue'
import detail from '@/views/notice/detail.vue'
import news from '@/views/news/index.vue'
import newsDetail from '@/views/news/detail.vue'
import brand1 from '@/views/brand/brand1.vue'
import brand2 from '@/views/brand/brand2.vue'
import brand3 from '@/views/brand/brand3.vue'
import brand4 from '@/views/brand/brand4.vue'
import brand5 from '@/views/brand/brand5.vue'
import brand6 from '@/views/brand/brand6.vue'
import brand7 from '@/views/brand/brand7.vue'
import brand8 from '@/views/brand/brand8.vue'

Vue.use(Router)

export default new Router({
	base: '/wap/',
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'index',
			component: Index,
			redirect: to => {
				return 'notice/index'
			},
		},
		{
			path: '/news',
			name: 'news',
			component: news,
		},
		{
			path: '/news/:id',
			name: 'newsDetail',
			component: newsDetail,
		},
		{
			path: '/notice/detail/:id',
			name: 'detail',
			component: detail,
		},
		{
			path: '/notice',
			name: 'notice',
			component: Notice,
			redirect: to => {
				return 'notice/index'
			},
			children: [
				{
					path: 'index',
					name: 'noticeIndex',
					component: noticeIndex
				},
				{
					path: 'list/:type',
					name: 'noticeList',
					component: noticeList,
				},
				{
					path: '/co/:type',
					name: 'coList',
					component: coList,
				},
				{
					path: '/stock',
					name: 'stock',
					component: stock,
				},
			]
		},
		{
			path:'/brand1',
			name: 'brand1',
			component: brand1,
		},
		{
			path:'/brand2',
			name: 'brand2',
			component: brand2,
		},
		{
			path:'/brand3',
			name: 'brand3',
			component: brand3,
		},
		{
			path:'/brand4',
			name: 'brand4',
			component: brand4,
		},
		{
			path:'/brand5',
			name: 'brand5',
			component: brand5,
		},
		{
			path:'/brand6',
			name: 'brand6',
			component: brand6,
		},
		{
			path:'/brand7',
			name: 'brand7',
			component: brand7,
		},
		{
			path:'/brand8',
			name: 'brand8',
			component: brand8,
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js